export function useNavigationFlags() {
  const isPlanPageFlag = useFlag('permission.dashboard.plan.view')
  const isAdminAreaFlag = useFlag('permission.admin.dashboard.view')
  const isSupportContactFlag = useFlag('permission.support.contact')
  const isManageGroupsFlag = useFlag('permission.admin.groups.manage')

  return {
    isPlanPageFlag,
    isAdminAreaFlag,
    isSupportContactFlag,
    isManageGroupsFlag,
  }
}

export function useSignatureRequestFlags() {
  const isAddObserverFlag = useFlag('permission.sr.observer.add')
  const isSendReminderFlag = useFlag('permission.sr.reminder.send')
  const isDownloadProtocolFlag = useFlag('permission.sr.protocol.download')

  const isAttachmentsFlag = useFlag('permission.invitation.attachments.upload')

  const isUploadMultipleDocsFlag = useFlag('permission.sr.documents.upload.multiple')

  return {
    isAddObserverFlag,
    isSendReminderFlag,
    isDownloadProtocolFlag,
    isAttachmentsFlag,
    isUploadMultipleDocsFlag,
  }
}

export function useVisualSignatureFlags() {
  const isCreateSignatureFlag = useFlag('permission.visual-signature.create')
  const isUploadImageFlag = useFlag('permission.visual-signature.image.upload')
  const isEditDateFlag = useFlag('permission.visual-signature.date.edit')
  const isEditClaimFlag = useFlag('permission.visual-signature.claim.edit')
  const isEditStandardsFlag = useFlag('permission.visual-signature.standards.edit')

  return {
    isCreateSignatureFlag,
    isUploadImageFlag,
    isEditDateFlag,
    isEditClaimFlag,
    isEditStandardsFlag,
  }
}

export function useReleaseFlags() {
  const isAddObserverGroupFlag = useFlag('release.observer-groups')
  const isCustomEmailDomainFlag = useFlag('release.custom-email-domain')
  const isFreeSignerSeatsFlag = useFlag('release.free-signer-seats')
  const isUserManagementApiFlag = useFlag('release.user-management-api')

  return {
    isAddObserverGroupFlag,
    isCustomEmailDomainFlag,
    isFreeSignerSeatsFlag,
    isUserManagementApiFlag,
  }
}

// Every running experiment and its possible variants, in one place.
const EXPERIMENTS = {
  'experiment.ujo-invite-loop-message': ['control', 'v1'],
} as const

/**
 * Returns the name of the experiment's variant resolved from Unleash or undefined in the case the experiment is off or Unleash only has the unauthenticated context
 */
function useExperiment(name: keyof typeof EXPERIMENTS) {
  const rawVariant = useVariant(name)

  return computed(() => EXPERIMENTS[name].find(variant => variant === rawVariant.value?.name))
}

/**
 * The variant name of every running experiment. Add new experiments to
 * EXPERIMENTS and expose them here; remove them when the experiment concludes.
 */
export function useActiveExperiments() {
  return {
    ujoInviteLoopMessageVariant: useExperiment('experiment.ujo-invite-loop-message'),
  }
}
